<script>
export default {
    name: "CookieSelector",
    props: ["value"],
    emits: ["input"],
    computed: {
        analyticsCookies: {
            get: function () {
                return this.value.analyticsCookies
            },
            set: function (value) {
                this.$emit("input", { ...this.value, analyticsCookies: value })
            },
        },
    },
}
</script>

<template>
    <div class="cookie-selector">
        <div>
            <p class="text-primary">
                {{ $t("cookie_consent.custom_selection_description") }}
            </p>
        </div>
        <div class="accordion">
            <div class="card p-0">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h2 class="mb-0">
                        <button
                            class="btn btn-link btn-block text-left collapsed"
                            type="button"
                            v-b-toggle.collapseNecessary
                        >
                            {{ $t("cookie_consent.necessary_cookies") }}
                        </button>
                    </h2>
                    <div class="custom-control custom-switch">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="necessaryCookiesSwitch"
                            checked
                            readonly
                            disabled
                        />
                        <label class="custom-control-label" for="necessaryCookiesSwitch"></label>
                    </div>
                </div>
                <b-collapse id="collapseNecessary" accordion="cookieAccordion" role="tabpanel">
                    <div class="card-body">
                        {{ $t("cookie_consent.necessary_cookies_description") }}
                    </div>
                </b-collapse>
            </div>
            <div class="card p-0">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h2 class="mb-0">
                        <button
                            class="btn btn-link btn-block text-left collapsed"
                            type="button"
                            v-b-toggle.collapseAnalytics
                        >
                            {{ $t("cookie_consent.analytics_cookies") }}
                        </button>
                    </h2>
                    <div class="custom-control custom-switch">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="analyticsCookiesSwitch"
                            v-model="analyticsCookies"
                        />
                        <label class="custom-control-label" for="analyticsCookiesSwitch"></label>
                    </div>
                </div>
                <b-collapse id="collapseAnalytics" accordion="cookieAccordion" role="tabpanel">
                    <div class="card-body">
                        {{ $t("cookie_consent.analytics_cookies_description") }}
                    </div>
                </b-collapse>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
